angular.module('salesPath2')
    .controller('clientAndVehicleSearchCtrl', ['$scope', '$state', 'CONFIG', 'CONSTANTS', 'applicationHelper', 'searchHelper', 'mainDataContainer', 'vehicleModalHelper', 'shortPathHelper', '$filter', 
    function ($scope, $state, CONFIG, CONSTANTS, applicationHelper, searchHelper, mainDataContainer, vehicleModalHelper, shortPathHelper, $filter) {
        $scope.numericSettings = {
            decimal: '',
            separator: '',
            negative: false,
            absolute: true,
            allowBeginZero: true
        };
        
        $scope.responsShorPath = {
            messages: {
                errors: []
            }
        };

        $scope.tplData = searchHelper.tplData;

        $scope.searchBtnClicked = function () {     
            $scope.goToShortPath($scope.tplData.searchData.pesel, $scope.tplData.searchData.registration);
        };

        $scope.$on('$locationChangeStart', function(event, next) {
            // if going forward to shortPath page
            if (next.indexOf('shortPath') !== -1) {
                event.preventDefault();  
                $scope.goToShortPath($scope.tplData.searchData.pesel, $scope.tplData.searchData.registration);
            }
        });        
        
        $scope.getErrors = function (errorsCode) {
            if( !errorsCode || !angular.isArray(errorsCode) || errorsCode.length === 0) {
                return [];
            }

            var vehicleNotAvailableInPackage = Object.values(errorsCode).some(function (code) {
                return code === 'ShortPath0002';
            });
            
            var translateLabelCode = vehicleNotAvailableInPackage
                ? 'sp2.shortPath.vehicleNotAvailableInPackage'
                : 'sp2.clientAndVehicleSearch.noDataErrorMsg';
                
            return [$filter('translate')(translateLabelCode, {componentCode: 'sp2' })];
        };

        $scope.goToShortPath = function (pesel, registration) {
            applicationHelper.createApplicationForShortPath(
                CONFIG.METADATA.applicationSymbol,
                pesel,
                registration
            ).then(function (errorsCode) {                
                $scope.responsShorPath.messages.errors = $scope.getErrors(errorsCode);
                var isCorrectResponse = $scope.responsShorPath.messages.errors.length === 0;
                
                if (isCorrectResponse){                                       
                    // temp hack, poki co z uslugi przychodiz jako pusty array, a powinno jako null
                    mainDataContainer.vehicles[mainDataContainer.selectedVehicle].equipments = null;
                    shortPathHelper.replaceZerosWithNulls(mainDataContainer.vehicles[mainDataContainer.selectedVehicle]);
                    vehicleModalHelper.editVehicle(mainDataContainer.selectedVehicle, true);

                    // logika sprawdzania czy pojazd z etx czy poza, zeby na widoku shortPath zaprezentowac od razu odpowiedni formularz
                    // jesli nie ma vehicle type (etx code) 
                    if(mainDataContainer.vehicles[mainDataContainer.selectedVehicle] && !mainDataContainer.vehicles[mainDataContainer.selectedVehicle].type[1]) {
                        // jesli _dataSource !== 'Eurotax' && _dataSource !== 'EurotaxFromPolicy' to pokaz od razu formularz poza etx
                        if (mainDataContainer.vehicles[mainDataContainer.selectedVehicle].dynVals._dataSource !== 'Eurotax' &&
                            mainDataContainer.vehicles[mainDataContainer.selectedVehicle].dynVals._dataSource !== 'EurotaxFromPolicy'
                        ) {
                            shortPathHelper.data.context = 'nonetx';
                            $state.go(CONSTANTS.PAGE_START_SHORT_PATH);
                        } else {
                            // pojazd z etx (_dataSource = Eurotax) niejednoznacznie zidentyfikowany, pokaz okno wyszukiwania pojazdu
                            shortPathHelper.data.etxVehicleIdentified = false;
                            $state.go(CONSTANTS.PAGE_START_SHORT_PATH);
                        }
                    } else {   
                        shortPathHelper.data.etxVehicleIdentified = true;                     
                        $state.go(CONSTANTS.PAGE_START_SHORT_PATH);
                    }

                }
            });
        };
    }]);